import * as types from './radActionType';

// Custom View Actions - start
export const getAllCustomViewsRequest = () => ({
    type: types.GET_ALL_CUSTOM_VIEWS_REQUEST
});
export const getAllCustomViewsSuccess = (data) => ({
    type: types.GET_ALL_CUSTOM_VIEWS_SUCCESS,
    payload: data
});
export const getAllCustomViewsFailure = (error) => ({
    type: types.GET_ALL_CUSTOM_VIEWS_FAILURE,
    payload: error
});

export const getCustomViewFieldsRequest = (viewId) => ({
    type: types.GET_CUSTOM_VIEW_FIELDS_REQUEST,
    payload: viewId
});
export const getCustomViewFieldsSuccess = (data) => ({
    type: types.GET_CUSTOM_VIEW_FIELDS_SUCCESS,
    payload: data
});
export const getCustomViewFieldsFailure = (error) => ({
    type: types.GET_CUSTOM_VIEW_FIELDS_FAILURE,
    payload: error
});

export const saveCustomViewFieldsRequest = (viewData) => ({
    type: types.SAVE_CUSTOM_VIEW_FIELDS_REQUEST,
    payload: viewData
});
export const saveCustomViewFieldsSuccess = (data) => ({
    type: types.SAVE_CUSTOM_VIEW_FIELDS_SUCCESS,
    payload: data
});
export const saveCustomViewFieldsFailure = (error) => ({
    type: types.SAVE_CUSTOM_VIEW_FIELDS_FAILURE,
    payload: error
});

export const updateRadReducer = (data) => ({
    type: types.UPDATE_RAD_REDUCER ,
    payload: data
});

// Custom View Actions - end
